export default {
    header: {
        title: '全案营销定制服务商',
        page1: '首页',
        page2: '关于WITSTAR',
        page3: '成功案例',
        page4: '服务',
        page5: '联系我们',
        page6: '品牌出海',
    },
    footer: {
        page1: '首页',
        page2: '关于WITSTAR',
        page3: '成功案例',
        page4: '服务',
        page5: '联系我们',
        phone: '手机',
        email: '邮箱',
        address: '地址',
        addressDesc: '中国深圳市龙岗区坂田生态科技园C栋3楼305',
        internet: '© 2024.智广思达.版权所有 粤ICP备2023093369号-1',
    },
    home: {
        title1: '全案营销定制服务商',
        desc1: '与伟大品牌同行',
        title2 : '智广思达',
        desc2_1: 'WITSTAR (智广思达)作为一家知名的品牌全案营销科技企业，致力于通过提供全链路、全渠道、全场景的定制化解决方案，为国内外品牌挖掘线上线下全生命周期的增长机会。在数字营销、IT定制开发、品牌出海、公关传播等业务上为品牌赋能，实现高效增长。',
        desc2_2: '目前，我们在深圳、吉隆坡均有公司及办事处，拥有超过100多名全职员工，涵盖品牌创作、IT定制开发、媒体运营、视频创作、公关活动服务等多领域专业人员。',
        title3: '我们的服务',
        desc3: '服务的本质是客户满意，满意的支撑是足够专业',
        title4: '精选案例',
        desc4: '像他们一样，通过智广思达服务实现业务增长',
        featured: {
            title1: '亨吉利',
            desc1: '品牌产品视觉形象官方网站全面设计开发升级等',
            know: '了解更多',
            title2: 'Dr吹风机',
            desc2: '品牌视觉理念:自然轻抚，晓风而至成就优雅新风尚',
            title3: '好孩子',
            desc3: '策划并成功打造了品牌形象助力品牌营销战略布局',
            title4: '索爱品牌',
            desc4: '友好舒透、更年轻的生活方式，带给用户简单、快乐的舒适感，愉悦身心',
        },
        advantage: {
            title:  '我们的优势',
            title1: '媒体资源',
            desc1: '实时更新媒体资源库15860+家，包含平面报纸、权威平台、门户网站等',
            title2: '达人资源',
            desc2: '实时126300+达人资源库，包含国内外各大主流媒体、行业垂直平台等',
            title3: '活动资源',
            desc3: '拥有丰富经验上1650+场的线上线下执行团队，提供精细化流程管理',
            title4: '数字技术',
            desc4: '富有创造性的软件开发及维护129+人团队，提供定制化、专业化的数字体系建设'

        },
        number: {
            title1: '媒体资源',
            title2: '达人资源',
            title3: '活动资源',
            title4: '数字技术',
            desc1: '家',
            desc2: '达人',
            desc3: '场',
            desc4: '人',
        },
        title5: '合作媒体',
        desc5: '一站式社媒代运营解决方案',
        title6: '我们的合作伙伴',
        desc6: '服务的本质是客户满意，满意的支撑是足够专业',

    },
    witstar: {
        title1: '为客户找到全案营销最优解',
        desc1: '我们是谁',
        title2: '让您的品牌出海更轻松',
        title3: '让您的品牌',
        title4: '价值更彰显',
        title5: '让您的品牌传播更全面',
        title6: '让您的品牌',
        title7: '声音更震撼',

    },
    brandOverseas: {
        title1: '让全世界聆听您的故事',
        desc1: '推动品牌出海',
        title2: '品牌出海全链路服务',
        desc2_1: 'Witstar是跨境品牌出海数字营销服务商，专注为客户提供品牌出海一站式解决方案',
        desc2_2: '通过品销一体战略思维、项目制指标化管理方法、多元化的销售渠道、丰富的营销经验及资源，赋能中国跨境电商企业品牌出海。',
        serveLine: {
            title1: '亚马逊一站式运营',
            title2: '多渠道拓展',
            title3: '独立站运营',
            title4: '海外众筹',
            title5: '社媒&红人品牌营销',
            title6: 'AI智能广告投放系统',
            title7: '亚马逊等多平台VC分销',
            title8: '广告优化及内容创意服务',
        },
        whatsapp: {
            title1: '天',
            title2: '内实现',
            title3: '全网曝光率增长',
            title4: '通过素人网红(KOC)和新闻矩阵，确保在消费者旅程的每个关键点向潜在客户引导消费，进阶DIGITALMARKETING营销策略。',
            title5: '小红书博主',
            title6: 'OWHATSAPP询问网红列表',
            title7: '',
            title8: '',
        },
        caseData: {
            title1: '真实案例 · 效果数据',
            title2: '成交率提升',
            title3: '销售时间減少',
            title4: 'WitStar通过TikTok、小红书、Instagram、Facebook和Go0gle为企业打造良好品牌声誉，进行潜在客户的二次营销，正面推荐促进购买决策，同时减少因缺乏正面品牌信息而流失的客户，提升成交率。',
            title5: '相关数据来源于WitStar售后服务团队，样品数量为273个',
            title6: '建立品牌信任是商业中的挑战，销售人员常需大力介绍产品和品牌。WitStar用网红见证和权威新闻稿增强企业社会认证，助销售快速赢得客户信心。',
        }
    },
    success: {
        title1: '全球化的创意 强大的执行力',
        desc1: '我们的案例',
        title2: '每一次服务都是一次口碑传播的机会',
        title3: '服务的本质是客户满意，用心做好每个方案打好每场仗对客户负责',
    },
    serve: {
        title1: '我们的服务',
        desc1_1: '服务的本质是客户满意',
        desc1_2: '满意的支撑是足够专业',
        desc2: '创意服务',
        desc3: '我们打造符合品牌策略的创意内容，帮品牌与其目标受众同频对话并产生情感联系',
        title2: '品牌VI设计',
        title3: '视觉设计',
        title4: '网页设计',
        title5: '文案撰写',
        title6: '创意短视频',
        overseas: {
            title1: '快速提升品牌海外知名度实现业务高效增长',
            title2: '提供品牌DTC出海全案营销服务',
            title3: '出海全案整合',
            title4: '品牌出海调研',
            title5: '海外社媒营销',
            title6: '海外KOL营销',
            title7: '海外线下活动策划',
            title8: '海外媒体及广告投放',
            title9: '品牌出海',
        },
        title7: '技术开发',
        title8: 'APP定制开发',
        title9: '微信公众号',
        title10: '小程序开发',
        title11: '网站升级定制开发',
        communicate: {
            title1: '公关传播',
            title2: '经验丰富的公关团队，充分利用线上线下传播手段，为品牌创造良好的经济和社会效益',
            title3: '活动传播',
            title4: '线下发布会',
            title5: '媒体沟通',
            title6: '媒体直播',
            title7: '新媒体营销',
        }
    },
    contact: {
        title1: '全案营销定制服务商',
        desc1: '联系我们',
        title2: '定制化营销推广助力中国品牌杨帆',
        title3: '品牌曝光',
        title4: '引流转化',
        title4_1: '打造爆品',
        title5: 'Tiktok海外营销一站式服务',
        title6: '网红营销',
        title7: '代运营服务',
        title8: '全案服务',
        table: {
            top: '涵盖区域',
            title1: '亚洲',
            desc1: '中国、日本、韩国、菲律宾、泰国、新加坡、马来西亚、印尼、印度、越南、柬埔寨、孟加拉、巴基斯坦、老挝、文莱...',
            title2: '欧洲',
            desc2: '英国、法国、德国、捷克、 俄罗斯、荷兰、比利时、挪威、瑞士、波兰、意大利、西班牙、葡萄牙、乌克兰...',
            title3: '美洲(南&北)',
            desc3: '美国、阿根廷、加拿大、智利、哥伦比亚、乌拉圭、罣西哥...',
            title4: '非洲',
            desc4: '埃及、冈比亚、几内亚、刚果、加纳、津巴布韦、肯尼亚、利比亚、南非、尼日利亚、乌干达...',
            title5: '大洋洲',
            desc5: '澳大利亚、新西兰、斐济、所罗门群岛...',
            bottom: '如果目标区域、国家不在上诉列表之上，欢迎咨询我们以获得更多详情。'
        }
    }
}